import { Box } from '@mui/material'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'

export type SortDirection = 'asc' | 'desc' | null

const caretOpacity = (direction: SortDirection, caret: 'asc' | 'desc'): number =>
  direction == null || direction === caret ? 1 : 0.3

export const SortCaretsIcon = ({ direction }: { direction: SortDirection }): JSX.Element => (
  <Box
    component='span'
    aria-hidden
    data-sort-direction={direction ?? 'none'}
    sx={{ display: 'inline-flex', flexDirection: 'column', color: 'var(--grey-700)', '& svg': { fontSize: '16px', my: '-5px' } }}
  >
    <ArrowDropUpIcon sx={{ opacity: caretOpacity(direction, 'asc') }} />
    <ArrowDropDownIcon sx={{ opacity: caretOpacity(direction, 'desc') }} />
  </Box>
)
